import { type ReactNode } from 'react';

export function ProgressDots({
  total,
  current,
}: {
  total: number;
  current: number;
}): ReactNode {
  return (
    <div className="flex justify-center gap-sm">
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={`h-1.5 w-6 rounded-full transition-colors ${i <= current ? 'bg-brand-red' : 'bg-white/[0.08] backdrop-blur-xl'}`}
        />
      ))}
    </div>
  );
}
